<template>
  <div class="my-list">
    <div class="tabs">
      <div :class="'tab-item '+(status===''?'tab-item-active':'')" @click="changeStatus('')">全部</div>
      <div :class="'tab-item '+(status==='3'?'tab-item-active':'')"  @click="changeStatus('3')">待回复</div>
      <!-- <div :class="'tab-item '+(status==='4'?'tab-item-active':'')"  @click="changeStatus('4')">已回复</div> -->
      <div :class="'tab-item '+(status==='1'?'tab-item-active':'')"  @click="changeStatus('1')">发布成功</div>
      <div :class="'tab-item '+(status==='0'?'tab-item-active':'')"  @click="changeStatus('0')">审核中</div>
      <div :class="'tab-item '+(status==='2'?'tab-item-active':'')"  @click="changeStatus('2')">审核失败</div>
    </div>
    <div class="post-list" v-if="dataList&&dataList.length">
      <div class="post-info" v-for="item in dataList" :key="item.id">
        <div class="post-info-img"  @click="routerHandle(item.id)">
          <img :src="item.userAvatarUrl" width="74px" height="74px" :alt="item.postsName"/>
        </div>
        <div class="post-detail"  @click="routerHandle(item.id)">
          <div class="post-detail-title overell">{{item.articleTitle}}</div>
          <div class="post-detail-content">{{item.articleContent}}</div>
          <div class="post-detail-time">
            <span>{{item.postsName}} &nbsp;上传&nbsp;|&nbsp;</span>
            <span>{{item.replyCount}} &nbsp;回复&nbsp;|&nbsp;</span>
            <span>提问时间：{{item.createTime}}</span>
          </div>
          <div v-if="item.expertUserRepliyPostVo">
            <div class="post-reply-content">{{item.expertUserRepliyPostVo.repliyPostContent}}</div>
            <div class="post-reply-time">回复时间：{{item.expertUserRepliyPostVo.createTime}}</div>
          </div>
        </div>
        <div class="post-status">
          <div v-if="item.expertAcceptanced&&!item.expertUserRepliyPostVo">待回复</div>
          <!-- <div v-else>已回复</div> -->
          <div v-else-if="item.expertUserRepliyPostVo&&item.expertUserRepliyPostVo.examined===1" class="post-status-success">回复成功</div>
          <div v-else-if="item.expertUserRepliyPostVo&&item.expertUserRepliyPostVo.examined===0" class="post-status-ing">回复提交，审核中<br/>请耐心等待......</div>
          <div v-else-if="item.expertUserRepliyPostVo&&item.expertUserRepliyPostVo.examined===2" class="post-status-fail">回复失败</div>
          <div v-if="item.expertUserRepliyPostVo&&item.expertUserRepliyPostVo.examined!==1" class="post-status-success-del" @click="deleteHandle(item)">删除</div>
          <!-- <div @click="">评价</div> -->
        </div>
      </div>
    </div>
    <div v-else>
      <div style="text-align:center">
        <img :src="BASE_URL + 'img/kong.png'" alt="暂无数据">
      </div>
    </div>
    <div class="doclist-pagination" v-if="dataList&&dataList.length">
      <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{lastOmit}}</div>
      <ul>
        <li :class="item === currentPage?'pageactive':''" v-for="item in pageList" :key="item" @click="changePageTo(item)">{{item}}</li>
      </ul>
      <div class="doclist-omit">{{nextOmit}}</div>
      <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
      <div class="doclist-jump" @click="jumpFarPage">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      status: '',
      dataList: [],
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1 // 跳转页
    }
  },
  computed: {
    // 计算属性的 getter
  },
  mounted () {
    this.getDataList(this.currentPage)
  },
  methods: {
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      this.getDataList(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    getDataList (currentPage = this.currentPage) {
      let expertAcceptanced = ''
      if (this.status === '3') {
        expertAcceptanced = '1'
      } else if (this.status === '4') {
        expertAcceptanced = '0'
      }
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertuserarticle/findNeedReplyArticles`, {
        'page': 1,
        'limit': 10,
        'expertAcceptanced': expertAcceptanced,
        'examined': this.status === '3' || this.status === '4' ? '' : this.status
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.dataList = data.data.data || []
            this.totalPage = Math.ceil(Number(data.data.count) / 10)
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.setPageTo(currentPage)
        })
        .catch(() => {
        })
    },
    setPageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    changeStatus (index) {
      this.status = index
      this.getDataList(1)
    },
    routerHandle (id) {
      this.$router.push({
        name: 'postsDetail',
        query: {
          id: id
        }
      })
    },
    // 删除非审核通过的数据
    deleteHandle (item) {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/userevaluateinfo/deleteMyEvaluate`, {
        id: item.id,
        evaluateType: item.evaluateType
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.$message.success('删除成功')
            this.dataList = []
            this.totalPage = 0
            this.getDataList()
          } else {
          }
        })
        .catch(() => {
          // console.log(err.message)
        })
    }
  }
}
</script>
<style scoped lang="scss">
  .my-list{
    margin: 30px 80px;
  }
  .tabs{
    height: 48px;
    // margin: 0 69px;
  }
  .tab-item{
    display: inline-block;
    padding: 12px 16px;
    text-align: center;
    background: #FFFFFF;
    /* box-shadow: inset 0 -1px 0 0 #DDDDDD; */
    width: 88px;
    height: 46px;
    line-height: 22px;
    font-size: 14px;
    letter-spacing: 0;
    margin-right: 24px;
    cursor: pointer;
  }
  .tab-item-active{
    color: #1D65A8;
    border-bottom: 2px solid #1D65A8;
  }
  .tab-item-content{
    padding-top: 10px;
  }
  .post-info{
    margin-top: 30px;
    width: 100%;
    display: flex;
    border-bottom: 1px solid #eee;
  }
  .post-info-img{
    cursor: pointer;
    width: 74px;
    height: 74p;
  }
  .post-info-img img{
    width: 74px;
    height: 74p;
    border-radius: 37px;
    overflow: hidden;
  }
  .post-detail {
    cursor: pointer;
    width: 550px;
    margin-left: 30px;
  }
  .post-detail-title{
    text-align: left;
    line-height: 22px;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0.6px;
    height: 22px;
    margin-bottom: 10px;
  }
  .post-detail-content{
    width: 450px;
    text-align: left;
    line-height: 20px;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0.6px;
    height: 20px;
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .post-detail-time{
    line-height: 17px;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0.6px;
    padding-bottom: 14px;
    border-bottom: 1px solid #eee;
  }
  .post-reply-content{
    text-align: left;
    line-height: 22px;
    height: 44px;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0.6px;
    margin-top: 14px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-overflow:ellipsis;
  }
  .post-reply-time{
    line-height: 17px;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0.6px;
    height: 17px;
    margin-bottom: 13px;
    margin-top: 13px;
  }
  .post-status{
    width: 120px;
    text-align: center;
  }
  .post-status-success{
    text-align: center;
    line-height: 20px;
    font-size: 14px;
    color: #1D65A8;
    height: 20px;
  }
  .post-status-ing{
    text-align: left;
    line-height: 20px;
    font-size: 14px;
    color: #E2980A;
    width: 120px;
  }
  .post-status-fail{
    text-align: center;
    line-height: 20px;
    font-size: 14px;
    color: #BF1B22;
    height: 20px;
  }
  .post-status-success-del{
    text-align: center;
    line-height: 20px;
    font-size: 14px;
    color: #1D65A8;
    height: 20px;
    cursor: pointer;
  }
  /*分页*/
  .doclist-pagination{
  display: flex;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-top: 20px;
}
.doclist-pagination ul{
  display: flex;
}
.doclist-pagination ul li{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.doclist-omit{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage{
  font-size: 14px;
  color: #666666;
}
.doclist-nextpage{
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
}
.doclist-pagejump{
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input{
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
}
.doclist-jump{
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
}
.doclist-lastpage{
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage{
  user-select: none;
  cursor: pointer;
}
</style>
